import type {
  SelectedGifteeBoxReportsPropsMappedFromDispatch,
  SelectedGifteeBoxReportsPropsMappedFromState
} from '@console/containers/project/SelectionReportContainer';
import APITableContainer from '@console/containers/project/selectionReport/APITableContainer';
import BulkTableContainer from '@console/containers/project/selectionReport/BulkTableContainer';
import GCPTableContainer from '@console/containers/project/selectionReport/GCPTableContainer';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';

const styles = (): StyleRules => ({});

type AggregateGifteeBoxSelectedContentPercentageProps =
  SelectedGifteeBoxReportsPropsMappedFromState &
    SelectedGifteeBoxReportsPropsMappedFromDispatch &
    WithStyles<typeof styles>;

const SelectionReport: React.FC<
  AggregateGifteeBoxSelectedContentPercentageProps
> = ({ isApiProject, isGcpProject, isBulkProject }) => (
  <>
    {isApiProject && <APITableContainer />}
    {isBulkProject && <BulkTableContainer />}
    {isGcpProject && <GCPTableContainer />}
  </>
);

export default withStyles(styles)(SelectionReport);
